import React from "react";
import ReactDOM from "react-dom/client";
import App, { ROUTES } from "./App.tsx";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import store from "./redux/store.ts";
import { Slide, ToastContainer } from "react-toastify";
import Home from "./pages/Home/Home.tsx";
import CandidateFeedbackForm from "./pages/Forms/CandidateFeedbackForm.tsx";
import Error404 from "./pages/error/Error404.tsx";
import i18n from "./plugins/i18n";
import { I18nextProvider } from "react-i18next";

const router = createBrowserRouter([
  {
    path: ROUTES.HOME,
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: ROUTES.SUPPORT,
        element: <Navigate to={ROUTES.HOME} replace />,
      },
      {
        path: ROUTES.RESPONSE,
        element: <CandidateFeedbackForm />,
      },
      {
        path: ROUTES.Error404,
        element: <Error404 />,
      },
    ],
  },
]);

axios.interceptors.request.use(
  (config) => {
    config.withCredentials = true;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider {...{ i18n }}>
        <RouterProvider router={router} />
      </I18nextProvider>
      <ToastContainer
        position="bottom-center"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="colored"
        transition={Slide}
      />
    </Provider>
  </React.StrictMode>
);
